import { I18n } from '@calendly/i18n'

// i18n-tasks-use t('publisher.event_type_editor.sections.scheduling_settings.event_limits.notice.days')
// i18n-tasks-use t('publisher.event_type_editor.sections.scheduling_settings.event_limits.notice.hours')
// i18n-tasks-use t('publisher.event_type_editor.sections.scheduling_settings.event_limits.notice.mins')
export const getNoticeSummary = (minBookingTime, minBookingTimeType) => {
  if (!minBookingTime) {
    return I18n.t('publisher.event_type_editor.sections.scheduling_settings.not_set')
  }

  return I18n.t(`publisher.event_type_editor.sections.scheduling_settings.event_limits.notice.${minBookingTimeType}`,
    { count: parseFloat(minBookingTime) })
}

export const findAvailabilityMembership = (eventTypeMembershipsAttributes, membership) => {
  if (!membership) return null

  return (
    eventTypeMembershipsAttributes.find(({ userId, organizationInvitationId }) => (
      (membership.user_id && membership.user_id === userId)
      || (membership.organization_invitation_id && membership.organization_invitation_id === organizationInvitationId)
    ))
  )
}
